export default "__VITE_ASSET__B6t93vPL__"